const Colors = {
  primary: '#000000',
  secondary: '#ffff00',
  white: '#ffffff',
  gray: '#666666',
  lightGray: '#f0f0f0',
  backgroundGray: '#f8f9fa',
  darkerGray: '#d9d9d9',
  darkGray: '#333333',
  red: '#ff4d4f',
  warning: '#faad14',
  success: '#52c41a',
  activeGray: '#e6e6e6',
  gradientLeft: 'linear-gradient(135deg, #000000 0%, #ffffff 100%)',
  gradientBackground: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
  // Dashboard metric colors
  blue: '#1890ff',
  purple: '#722ed1',
  orange: '#fa541c',
  cyan: '#13c2c2',
  pink: '#eb2f96',
  darkRed: '#d4380d',
  darkBlue: '#096dd9',
  whatsapp: '#25D366',
  // Badge colors - light backgrounds
  lightBlue: '#e6f7ff',
  lightGreen: '#f6ffed',
  lightOrange: '#fff7e6',
  lightPurple: '#f9f0ff',
  lightPink: '#fff0f6',
  lightRed: '#fff1f0',
  lightCyan: '#e6fffb',
  lightYellow: '#fffbe6',
  // Badge colors - dark text
  darkBlueText: '#0050b3',
  darkGreenText: '#389e0d',
  darkOrangeText: '#d46b08',
  darkPurpleText: '#531dab',
  darkPinkText: '#c41d7f',
  darkRedText: '#cf1322',
  darkCyanText: '#08979c',
  darkYellowText: '#d48806'
}

export default Colors
